import React from 'react';

const Maintenance = () => {
    return (
        <div>
            <h1>System Under Maintenance</h1>
            <p>We're currently performing maintenance. Please try again later.</p>
        </div>
    );
};

export default Maintenance;
